var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',[_vm._v("\n  "+_vm._s(_vm._f("trans")('Actions'))+"\n")]):_c('td',[_c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-primary mb-1",on:{"click":function($event){_vm.addToReport(_vm.rowData, _vm.rowIndex)}}},[_c('i',{staticClass:"icons icon-plus"}),_vm._v(" "+_vm._s(_vm._f("translate")('Add to report')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cbb9d64","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueTableJointActions.vue
// module id = 1271
// module chunks = 75